/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import AnalyticsService from 'cio/services/analytics';
import { inject as service } from '@ember/service';

interface StartupPlanInfoArgs {
  cardCount: number;
}

export default class StartupPlanInfo extends Component<StartupPlanInfoArgs> {
  @service analytics!: AnalyticsService;

  @action
  trackStartupRequestViewed() {
    this.analytics.track('onboarding', 'pricing_card_button_clicked', { type: 'startup' });
  }
}
